import { useMemo } from "react";
import { useCategoryList, useProduct } from "../use-fetch-cosmicjs-state";
import { useSearch } from "../use-search";
import { useTitle } from "../../../../utils/use-title";

export const useHelpProductTopHomeController = (
  productId: string | undefined,
) => {
  const categoryListResult = useCategoryList(productId);

  return {
    categoryListResult,
  };
};

export const useHelpProductTopController = () => {
  const {
    result,
    query,
    onChangeQuery,
    condition,
    onChangeCondition,
    isLoading,
    productId,
    onChangeProduct,
    tags,
    onChangeTags,
  } = useSearch();

  const { product } = useProduct(productId);

  const title = "ヘルプサイト" as const;

  const subtitle = useMemo(() => {
    if (!product) return "";
    return product.title;
  }, [product]);

  useTitle(`${title} - ${subtitle} `);

  return {
    title,
    subtitle,
    result,
    isLoading,
    query,
    condition,
    productId,
    tags,
    onChangeSearchText: onChangeQuery,
    onChangeSearchCondition: onChangeCondition,
    onChangeProduct,
    onChangeTags,
  };
};
